import { RouteType } from "types/RouteType";
import ChangeOrderWizardStore from "./ChangeOrderWizardStore";

const ChangeOrderWizardRoute: RouteType = {
  name: "ChangeOrderWizard",
  path: "/workflows/change-order",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Change Order Management",
      component: () => import("./ChangeOrderWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ChangeOrderWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.changeOrderWizardStore) {
      rootStore.changeOrderWizardStore = new ChangeOrderWizardStore(
        rootStore
      );
    }
    await rootStore.changeOrderWizardStore.loadInitialData();
    return true;
  },
};

export default ChangeOrderWizardRoute;